const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function init() {
  if (reducedMotion.matches || window.Shopify?.designMode) return;

  const selectors = [
    '.section-resource-list__header',
    '.resource-list__item',
    '.media-with-content',
    '[id$="__section_faq"] .section',
    '.footer',
  ];
  const targets = document.querySelectorAll(selectors.join(', '));
  const revealThreshold = window.innerHeight * 0.9;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  let cardIndex = 0;
  for (const el of targets) {
    if (el.closest('[id*="__hero"]')) continue;
    if (el.getBoundingClientRect().top < revealThreshold) continue;
    if (el.classList.contains('resource-list__item')) {
      el.style.setProperty('--reveal-delay', `${(cardIndex % 4) * 30}ms`);
      cardIndex += 1;
    }
    el.classList.add('scroll-reveal');
    observer.observe(el);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
